import {useMemo} from 'react'
import {useGetConsumersQuery, useGetCurrentUserQuery, useGetStructuresQuery} from 'store/Store'
import {getDocumentId} from 'utils'
import RelationshipUpdateDateTrigger from 'components/Control/RelationshipUpdateDateTrigger'

const useFormMeterLogic = ({fields, methods}) => {
    const {data: user} = useGetCurrentUserQuery()
    const userAccount = useMemo(() => user?.account, [user])
    const {watch} = methods
    const [account, structure] = watch(['account', 'structure'])
    const {data: structures, isLoading: isLoadingStructure} = useGetStructuresQuery(
        {account: getDocumentId(account)},
        {skip: !userAccount && !account}
    )
    const {data: consumers, isLoading: isLoadingConsumer} = useGetConsumersQuery(
        {structure: getDocumentId(structure)},
        {skip: !structure}
    )

    fields.createMeter.items.structure.options = structures?.data || []
    fields.createMeter.items.structure.isLoading = isLoadingStructure
    fields.createMeter.items.consumer.options = consumers?.data || []
    fields.createMeter.items.consumer.isLoading = isLoadingConsumer

    const consumerField = fields.createMeter.items.consumer
    const structureField = fields.createMeter.items.structure

    consumerField.InputProps = {
        ...consumerField.InputProps,
        endAdornment: (
            <RelationshipUpdateDateTrigger
                fieldName="consumerUpdateDate"
                labelKey="consumerUpdateDate"
                actionKey="consumerUpdateDateAction"
            />
        ),
    }

    structureField.InputProps = {
        ...structureField.InputProps,
        endAdornment: (
            <RelationshipUpdateDateTrigger
                fieldName="structureUpdateDate"
                labelKey="structureUpdateDate"
                actionKey="structureUpdateDateAction"
            />
        ),
    }

    if (fields.relationshipUpdates) {
        fields.relationshipUpdates.hidden = true
    }

    return {fields}
}

export default useFormMeterLogic
